import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getTeamReport = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/getteamreport' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const changePicture = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/changepicture/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getMyUserGroupAll = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/getmyusergroupall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyUserGroupPage = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/getmyusergrouppage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const analyzeVehicleLicensePicture = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/analyzevehiclelicensepicture/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const changeBusinessUser = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/changebusinessuser/' + params.id + '/' + params.userId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const bindPositioningDeviceInfos = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/bindpositioningdeviceinfos/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const unBindPositioningDeviceInfos = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/unbindpositioningdeviceinfos/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchAddObj = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/batchadd' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const cancel = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/cancel/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const uploadAddFile = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/uploadaddfile' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const confirmUpload = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/confirmupload/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const confirmRecept = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/confirmrecept' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const omTest = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/omtest' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const callBack = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/callback' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchCallBack = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/batchcallback/' + params.installOrderList + '/' + params.state + '/' + params.result + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const reschedule = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/reschedule' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const distribution = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/distribution' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const importOrders = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/importorders' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const audit = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/audit' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getReport = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/getreport' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const batchAudit = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/batchaudit/' + params.installOrderList + '/' + params.state + '/' + params.result + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const generateInsuranceVideoCommitment = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/generateinsurancevideocommitment' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const changeInstaller = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/changeinstaller/' + params.id + '/' + params.installerId + '/' + params.installerlsit + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getMyBusinessPage = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/getmybusinesspage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyNotInstallNum = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/getmynotinstallnum' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyGroupNotInstallNum = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/getmygroupnotinstallnum' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const confirmInstalled = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/confirminstalled' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getMyInstallPage = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/getmyinstallpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const batchConfirmRecept = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/batchconfirmrecept/' + params.installOrderList + '/' + params.receptDatetime + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const forceConfirmInstalled = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/forceconfirminstalled' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getTeamOperatorReport = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/getteamoperatorreport' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const uploadInstallorderePicture = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/uploadinstallorderpicture/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const removeInstallorderePicture = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/removeinstallorderpicture/' + params.installorderpictureId + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const modifyInstallOrderBase = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/modifyinstallorderbase' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchDistribution = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/batchdistribution/' + params.installOrderList + '/' + params.state + '/' + params.result + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const generateMaterial = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/generatematerial/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const addToInstallRemark = (params, urlParams) => {
  return axios.request({
    url: '/om/installorder/addtoinstallremark/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}
